import styled from 'styled-components';

import { StyledInput } from 'assets/styles/sharedStyles';
import SearchIcon from 'components/Icons/SearchIcon';

export const StyledSearch = styled.div`
  margin: 0;
  position: relative;
`;

export const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  left: 10px;
  top: 8px;
  z-index: ${({ theme }) => theme.zIndex.three};

  html[dir='rtl'] & {
    right: 10px;
    left: 0;
  }
`;

export const SearchingIcon = styled.div`
  position: absolute;
  right: 50px;
  top: 10px;
  z-index: ${({ theme }) => theme.zIndex.six};

  html[dir='rtl'] & {
    right: inherit;
    left: 50px;
  }
`;

export const StyledCloseIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 7px;
  z-index: ${({ theme }) => theme.zIndex.six};

  html[dir='rtl'] & {
    right: inherit;
    left: 10px;
  }
`;

export const SearchInput = styled.input`
  ${StyledInput}

  padding: 9px;
  padding-left: 40px;
  border-color: ${({ theme }) => theme.color.borderGray};
  border-radius: 21px;
  overflow: hidden;

  ::placeholder,
  ::-webkit-input-placeholder {
    color: #999;
  }

  html[dir='rtl'] & {
    padding-left: 9px;
    padding-right: 40px;
  }
`;

export const ResultsContainer = styled.div`
  position: absolute;
  top: 65px;
  z-index: ${({ theme }) => theme.zIndex.one};
  width: calc(100% - 20px);
  margin: 0 10px;
  border-radius: 5px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  background-color: ${({ theme }) => theme.color.inputBackground};
  color: ${({ theme }) => theme.color.text};

  ::before {
    position: absolute;
    display: inline-block;
    border-left: 15px solid transparent;
    border-bottom: 20px solid ${({ theme }) => theme.color.inputBackground};
    border-right: 15px solid transparent;
    transform: rotate(0deg) translateX(-10px);
    left: 25px;
    top: -20px;
    content: '';
    filter: drop-shadow(-1px -2px 2px rgba(0, 0, 0, 0.2));
  }
`;

export const Results = styled.ul`
  padding: 20px 10px;
  max-height: 260px;
  overflow: auto;
  list-style: none;
`;

export const NoResult = styled.div`
  padding: 5px;
`;
